import React, { useState } from 'react';
import { Card, Progress, Typography, Empty } from 'antd';
import { AnalisePorSeveridade } from '../../../types/dashboard/csa.types';

const { Text } = Typography;

interface CSASeverityChartProps {
  data: AnalisePorSeveridade[];
  loading?: boolean;
  onSeverityClick?: (severity: string) => void;
}

const CSASeverityChart: React.FC<CSASeverityChartProps> = ({ 
  data, 
  loading = false,
  onSeverityClick
}) => {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  if (!data || data.length === 0) {
    return (
      <Card title="Distribuição por Severidade" size="small" loading={loading}>
        <Empty description="Nenhum dado disponível" />
      </Card>
    );
  }

  const handleItemClick = (severity: string) => {
    if (onSeverityClick) {
      onSeverityClick(severity);
    }
  };

  const handleMouseEnter = (index: number) => {
    if (onSeverityClick) {
      setHoveredIndex(index);
    }
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
  };

  return (
    <Card title="Distribuição por Severidade" size="small" loading={loading}>
      <div style={{ padding: '16px 0' }}>
        {data.map((item, index) => (
          <div 
            key={index} 
            style={{ 
              marginBottom: 16,
              cursor: onSeverityClick ? 'pointer' : 'default',
              padding: '8px',
              borderRadius: '4px',
              transition: 'background-color 0.2s ease',
              backgroundColor: hoveredIndex === index ? '#f5f5f5' : 'transparent'
            }}
            onClick={() => handleItemClick(item.severity)}
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={handleMouseLeave}
          >
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              marginBottom: 4 
            }}>
              <Text strong>{item.label}</Text>
              <Text>{item.count} ({item.percentual}%)</Text>
            </div>
            <Progress 
              percent={item.percentual} 
              strokeColor={item.color}
              showInfo={false}
              size="small"
            />
            {onSeverityClick && (
              <div style={{ 
                fontSize: '11px', 
                color: '#8c8c8c', 
                marginTop: '4px',
                textAlign: 'center'
              }}>
                Clique para filtrar
              </div>
            )}
          </div>
        ))}
      </div>
    </Card>
  );
};

export default CSASeverityChart;